import CachedIcon from '@mui/icons-material/Cached';
import { Button, IconButton, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';

// -------------
// Props
export type PageMinutesProps = {
  onRefreshGrid: () => void;
};

const PageMinutes = (props: PageMinutesProps) => {
    const { onRefreshGrid } = props;
    // minutes shown in input and used by user
    const [minutes, setMinutes ] =  useState(30);
    const [minutesShow, setMinutesShow ] =  useState(30);
    // internal countdown in seconds
    const [intervalSeconds, setIntervalSeconds] = useState(minutes * 60);
    const [stopFlag, setStopFlag ] =  useState(false);
    useEffect(()=>{
        let temp = intervalSeconds;
        let myInterval = setInterval(() => {
            if (temp > 0) {
                temp--;
            }
            else {
                if (!stopFlag){
                    clearInterval(myInterval);
                }
                else {
                    onRefreshGrid();
                    temp = intervalSeconds;
                }
            }
        }, 1000)
        return ()=> {
            clearInterval(myInterval);
        };
    }, [stopFlag, intervalSeconds, onRefreshGrid]);

    useEffect(()=>{
        setStopFlag(false);
    },[minutesShow]);

    const HandleAutoUpdate = (flag: boolean) => {
        setIntervalSeconds((minutesShow || 0) * 60);
        setMinutes(minutesShow);
        setStopFlag(flag)
    }
  
    const onSetSeconds = () => {
        onRefreshGrid();
    }

    const onChange = (value: any) => {
        if(value.trim() === ""){
            setMinutesShow(NaN)
        }
        else if(Number(value) !== 0){
            setMinutesShow(parseInt(Number(value).toString()))
        }
    }

    const onBlur = (value: any) => {
        if(value.trim() === ""){
            setMinutesShow(1)
        }
    }
    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Stack direction="row">
                <div style={{marginInlineStart: 'auto'}}>
                    <Stack spacing={1}  direction="row">
                    <Button variant={stopFlag ? "contained" : "outlined"}  size="small" style={{marginBlock: 'auto'}} onClick={e =>HandleAutoUpdate(true)}>自動更新ON</Button>
                    <Button variant={!stopFlag ? "contained" : "outlined"} size="small" style={{marginBlock: 'auto'}} onClick={e =>HandleAutoUpdate(false)}>自動更新OFF</Button>
                    <TextField InputProps={{readOnly: stopFlag}} type="number" label = "更新間隔" size="small" variant="outlined" value={minutesShow}  onChange={(e:any)=>onChange(e.target.value)} inputProps={{style: { width: '100px' }, min: 1}} onBlur={(e:any)=>onBlur(e.target.value)}/>
                    <p style={{marginBlock: 'auto'}}>(分)</p>
                    <IconButton aria-label="edit" onClick={onSetSeconds} >
                        <CachedIcon fontSize="medium" style={{ color: '#1890ff' }} />
                    </IconButton>
                    </Stack>
                </div>
            </Stack>
        </div>
    );
};

export default PageMinutes;
